import React, { useState, useContext } from 'react';
import CheckList from '../../component/home/checklist/CheckList';
import { SubmitEmail } from '../../services/OnbordingService';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../AppContext';

export default function CheckListContainer() {
  const { setEmail, setCurrentStep, setOrdValue } = useContext(AppContext);
  const [localEmail, setLocalEmail] = useState("");
  const [error, setError] = useState("");
  const [showButton, setShowButton] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const baseURL = window.location.origin;
  const handleInputChange = (e) => {
    setLocalEmail(e.target.value);
  };


  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
  
    const trimmedEmail = localEmail.trim();
  
    if (!trimmedEmail) {
      setShowButton(false);
      setError("Email is required.");
      setLoading(false);
      return;
    }
  
    if (!validateEmail(trimmedEmail)) {
      setShowButton(false);
      setError("Please enter a valid email address.");
      setLoading(false);
      return;
    }
  
    setCurrentStep(2);
  
    try {
      const payload = { email: trimmedEmail, url: baseURL }; 
      const response = await SubmitEmail(payload);
  
      if (response && response.description) {
        setEmail(trimmedEmail); 
        setLocalEmail("");
        setOrdValue(response?.ord);
  
        navigate("/otp", { state: { email: trimmedEmail, ord: response.ord } });
      } else {
        setError("An error occurred. Please try again.");
      }
    } catch (err) {
      if (err.response && err.response.data) {
        const { code, description } = err.response.data;
  
        if (code === "M400" && description === "Application has already been submitted for your company.") {
          setShowButton(true);
          setError(description);
        } else if (description) {
          setShowButton(false);
          setError(description);
        } else {
          setShowButton(false);
          setError("An unexpected error occurred.");
        }
      } else {
        setError("An unexpected error occurred.");
      }
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <div>
      <CheckList
        handleSubmit={handleSubmit}
        handleInputChange={handleInputChange}
        error={error}
        email={localEmail}
        showButton={showButton}
        loading={loading}
      />
    </div>
  );
}
